import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EDiagnosisClassification;
(function (EDiagnosisClassification) {
  EDiagnosisClassification["Chronic"] = "chronic";
  EDiagnosisClassification["Episodic"] = "episodic";
})(EDiagnosisClassification || (EDiagnosisClassification = {}));
export const fieldsDiagnosis = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  classification: {
    type: 'Option',
    values: EDiagnosisClassification
  },
  date: {
    type: 'Date'
  },
  description: {
    type: 'Text'
  },
  endDate: {
    type: 'Date'
  },
  externalId: {
    type: 'Object'
  },
  icd10: {
    type: 'Text'
  },
  icd9: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  }
});